import { NitroModules } from "react-native-nitro-modules";
import { assertBarometerListener, assertUpdateInterval } from "./validate";
var hybrid;
function native() {
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = NitroModules.createHybridObject("OneBarometer");
  return hybrid;
}
function isAvailable() {
  return native().isAvailable();
}
function setUpdateInterval(intervalMs) {
  assertUpdateInterval(intervalMs);
  native().setUpdateInterval(intervalMs);
}
function addListener(listener) {
  assertBarometerListener(listener);
  var remove = native().addListener(listener);
  return {
    remove: function remove1() {
      return remove();
    }
  };
}
var Barometer = Object.freeze({
  isAvailable,
  setUpdateInterval,
  addListener
});
export {
  Barometer
};
//# sourceMappingURL=index.native.js.map
